<template>
  <div class="gallery-hover">
    <figure :class="['gallery-hover--hero', 'gallery-hover--hero--' + heroSize]">
      <img class="gallery-hover--img" v-lazy:backgroundImage="heroImage.url"/>
      <transition name="view-fade-slow">
      <div class="gallery-hover--popup"
        :style="[popStyle]"
        v-if="selectedImg && selectedImg.url">
        <img ref="selected" :src="selectedImg.url" />
      </div>
      </transition>
      <slot name="hero" class="gallery-hover--hero-slot">
      </slot>
    </figure>
    <div class="gallery-hover--thumb-wrapper"
      v-if="!hasGalleryHidden && gallery.length > 0" v-once>
      <figure
        v-for="it in 5"
        :key="it"
        :class="['gallery-hover--thumb']"
        @mouseover.stop.prevent="mouseover(gallery[it - 1] && gallery[it - 1].s)"
        @mouseout.stop.prevent="mouseout"
        >
        <i class="gallery-hover--img" v-lazy:backgroundImage="gallery[it - 1] && gallery[it - 1].s.url"/>
      </figure>
    </div>
    <div class="gallery-hover--thumb-wrapper"
      v-if="!hasGalleryHidden && gallery.length > 5" v-once>
      <figure
        v-for="it in 5"
        :key="it"
        :class="['gallery-hover--thumb']"
        @mouseover.stop.prevent="mouseover(gallery[it + 4] && gallery[it + 4].s)"
        @mouseout.stop.prevent="mouseout">
        <i class="gallery-hover--img" v-lazy:backgroundImage="gallery[it + 4] && gallery[it + 4].s.url"/>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyGalleryHover',
  props: {
    heroSize: {
      type: String,
      default: ''
    },
    gallery: {
      type: Array,
      default () {
        return [{ s: { fileName: 'xx', url: 'l' } }]
      }
    },
    hasGalleryHidden: {
      type: Boolean,
      default: false
    },
    heroImage: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      hoverGalleryVisibility: false,
      selectedImg: {},
      timer: undefined,
      popStyle: {
        height: 0,
        width: 0
      }
    }
  },
  computed: {
    heroSizeCss () {
      return `gallery-hover--img--${this.heroSize}`
    }
  },
  methods: {
    mouseover (val) {
      clearTimeout(this.timer)
      this.selectedImg = val
      this.hoverGalleryVisibility = true
      this.$nextTick(() => {
        if (this.selectedImg == null) return
        this.popStyle = {
          height: `${this.$refs.selected.naturalHeight + 6}px`,
          width: `${this.$refs.selected.naturalWidth + 6}px`
        }
      })
    },
    mouseout () {
      this.hoverGalleryVisibility = false
      this.timer = setTimeout(() => (this.selectedImg = {}), 300)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/bulma-variables';
  .gallery-hover {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .gallery-hover--img {
    width: 100%;
    height: 100%;
    display: block;
    opacity: 0;
    background-position: 50% 20%;
    background-size: cover;
    transition: 400ms opacity ease-in;
    &[lazy=loaded] {
      opacity: 1;
    }
  }
  .gallery-hover--popup {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    z-index: 10;
    display: block;
    box-shadow: 0 5px 5px  rgba(10, 10, 10, 0.2), 0 10px 50px 10px rgba(10, 10, 10, 0.2);
    & > img {
      display: block;
      margin: $bleed /2 ;
    }
  }
  .gallery-hover--hero {
    width: 100px;
    height: 100px;
    position: relative;
    border-radius: $bleed 0 0 0;
    flex: 1;
    &.gallery-hover--hero--large {
      width: 224px;
      height: 160px;
    }
    box-shadow: inset 0 0 40px 5px rgba(10, 10, 10, 0.1);
    display: block;
  }
  .gallery-hover--hero-slot {
    position: absolute;
    bottom: 0;
    padding: $bleed;
    right: 0;
    color: $link;
    background-color: rgba(0,0,0,.3);
    // text-shadow: 0 0px 15px rgba(0,0,0,.9);
    // border-radius: $bleed / 2;
    &:active,
    .gallery-hover--hero:active &
     {
      bottom: -2px;
    }
  }
  .gallery-hover--thumb-wrapper {
    display: flex;
    border-radius: 0 0 0 $bleed;
  }
  .gallery-hover--thumb {
    margin: $bleed / 2 $bleed / 2 0 0;
    box-shadow: inset 0 0 40px 5px rgba(10, 10, 10, 0.1);
    flex: 1;
    height: 50px;
    opacity: 0.7;
    &:hover{
      opacity: 1;
    }
    &:last-child {
      margin-right: 0;
    }
  }
</style>
